import React, { useEffect, useMemo, useRef } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'devextreme-react/form'
import Button from 'devextreme-react/button'
import { useMediaQuery } from '@react-hooks-library/core'

const buildForm = (options) => {
  return options.map(({ id, nombre }) => (
    {
      colSpan: 1,
      label: {
        visible: true,
        text: nombre,
        location: 'left'
      },
      dataField: id,
      editorType: 'dxCheckBox'
    }
  ))
}

const MultipleField = ({ question, options, submit }) => {
  const isLargeScreen = useMediaQuery('(min-width: 640px)')
  const items = useMemo(() => buildForm(options), [options])
  const formRef = useRef()
  const respuesta = question.respuestas_multiple

  const submitCallback = () => {
    const form = formRef.current.instance
    const formData = form.option('formData')

    const selectedOptions = Object.keys(formData).filter(key => formData[key])
    submit(selectedOptions.join(','))
  }
  useEffect(() => {
    const form = formRef.current.instance
    if (!respuesta) return
    const respuestas = respuesta.split(',')
    const defaultValues = {}

    options.forEach(({ id }) => {
      defaultValues[id] = respuestas.includes(id)
    })

    form.option('formData', defaultValues)
  }, [options, respuesta])

  return (
    <>
      <Form ref={formRef} width='100%' colCount={3} items={items} onEditorEnterKey={submit} />
      <Button width={isLargeScreen ? 138 : '100%'} className='mt-5' icon='arrowright' type='success' style={{ backgroundColor: '#40c0c0' }} text='Continuar' onClick={submitCallback} />
    </>
  )
}

MultipleField.propTypes = {
  question: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  submit: PropTypes.func.isRequired
}

export default MultipleField
